import React from 'react';

function Privacidad() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 24px', fontFamily: 'system-ui, sans-serif', color: '#1e293b', lineHeight: '1.7' }}>
      <h1 style={{ fontSize: '28px', fontWeight: '800', marginBottom: '8px' }}>Política de Privacidad</h1>
      <p style={{ color: '#64748b', marginBottom: '32px' }}>Última actualización: febrero de 2026</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>1. Responsable del tratamiento</h2>
      <p>HabitaPro es el responsable del tratamiento de los datos personales recogidos a través de esta aplicación.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>2. Datos que recopilamos</h2>
      <p>Recopilamos los siguientes datos personales:</p>
      <ul style={{ paddingLeft: '20px' }}>
        <li>Nombre y apellidos</li>
        <li>Correo electrónico</li>
        <li>Datos de la comunidad de vecinos a la que pertenece</li>
        <li>Contenido de las incidencias, anuncios y documentos que el usuario crea</li>
        <li>Imágenes adjuntadas a las incidencias</li>
      </ul>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>3. Finalidad del tratamiento</h2>
      <p>Los datos se utilizan exclusivamente para:</p>
      <ul style={{ paddingLeft: '20px' }}>
        <li>Gestionar el acceso y autenticación a la aplicación</li>
        <li>Permitir la comunicación entre vecinos y administradores de la comunidad</li>
        <li>Gestionar incidencias, anuncios y documentos de la comunidad</li>
        <li>Enviar notificaciones relacionadas con la actividad de la comunidad</li>
      </ul>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>4. Base legal</h2>
      <p>El tratamiento de sus datos se basa en el consentimiento del usuario al registrarse en la aplicación, así como en el interés legítimo de la gestión comunitaria.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>5. Conservación de los datos</h2>
      <p>Los datos se conservan mientras el usuario mantenga su cuenta activa. Puede solicitar la eliminación de su cuenta y datos en cualquier momento.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>6. Comunicación a terceros</h2>
      <p>No se ceden datos a terceros salvo obligación legal. Los datos se almacenan en servidores seguros ubicados en la Unión Europea.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>7. Derechos del usuario</h2>
      <p>El usuario tiene derecho a acceder, rectificar, suprimir, limitar u oponerse al tratamiento de sus datos, así como el derecho a la portabilidad. Para ejercer estos derechos, puede contactar a través de la aplicación o enviar un correo al administrador de su comunidad.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>8. Seguridad</h2>
      <p>Aplicamos medidas técnicas y organizativas adecuadas para proteger sus datos frente a accesos no autorizados, pérdida o alteración, incluyendo cifrado de contraseñas y comunicaciones HTTPS.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>9. Cambios en esta política</h2>
      <p>Nos reservamos el derecho a actualizar esta política. Le notificaremos de cambios relevantes a través de la aplicación.</p>

      <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #e2e8f0' }} />
      <p style={{ color: '#94a3b8', fontSize: '13px' }}>© 2026 HabitaPro. Todos los derechos reservados.</p>
    </div>
  );
}

export default Privacidad;
